import { Body1, Header2 } from '@flatsy/core/MaterialUi/Typo'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import theme from '@flatsy/core/MuiTheme/theme'
import i18n from '@flatsy/utils/translations'
import DomainIcon from '@material-ui/icons/Domain'
import PlaceOutlinedIcon from '@material-ui/icons/PlaceOutlined'
import clsx from 'clsx'
import React from 'react'
import { useApplicationBooking } from 'src/hooks/ApplicationBooking'
import { useMobile } from 'src/hooks/Mobile'
import { useStyles } from './Style'
import { AddressProps } from './Type'

const Address: React.FC<AddressProps> = ({ application }): React.ReactElement => {
  const classes = useStyles()
  const isMobile = useMobile()
  const { booking } = useApplicationBooking({ applicationId: application.id })
  const accessBuildingStyle =
    booking?.access_code || booking?.building ? classes.accessBuilding : undefined

  const renderAccessCode = () => {
    return isMobile ? (
      <Body1 fontColor={theme.palette.primary.dark}>
        {i18n.t('code')}
        {booking && booking.access_code}
      </Body1>
    ) : (
      <div className={classes.accesCode}>
        <Body1 fontColor={theme.palette.secondary.dark}>{i18n.t('access_code')} </Body1>
        <Body1 className={classes.accessBuildingText}>{booking && booking.access_code}</Body1>
      </div>
    )
  }

  const renderBuilding = () => {
    return isMobile ? (
      <Body1 fontColor={theme.palette.primary.dark}>
        {i18n.t('building')} {booking && booking.building}
      </Body1>
    ) : (
      <div className={classes.accesCode}>
        <Body1 fontColor={theme.palette.secondary.dark}>
          {i18n.t('building')} {i18n.t('@c')}
        </Body1>
        <Body1 className={classes.accessBuildingText}>{booking && booking.building}</Body1>
      </div>
    )
  }

  return (
    <div className={classes.card}>
      <Header2 lowerCase className={classes.title}>
        {i18n.t('how_to_get_there')}
      </Header2>
      <div className={classes.cardPlace}>
        <PlaceOutlinedIcon className={classes.iconGrey} />
        <Body1 fontColor={theme.palette.primary.dark}>{booking?.asset_address}</Body1>
      </div>
      <div className={accessBuildingStyle}>
        {booking?.access_code && (
          <div className={classes.cardPlace}>
            <img
              src={FlatsyTheme.image.iconAccessCode}
              alt="Access code"
              className={classes.iconGrey}
            />
            {renderAccessCode()}
          </div>
        )}
        {booking?.building && (
          <div
            className={
              booking?.access_code ? clsx(classes.cardPlace, classes.building) : classes.cardPlace
            }
          >
            <DomainIcon className={classes.iconGrey} />
            {renderBuilding()}
          </div>
        )}
      </div>
    </div>
  )
}

export default Address
